import { jwtDecode } from "jwt-decode"
import { useMemo } from "react"
import { useParams } from "react-router-dom"
import { useAppStore } from "@/api/app-store"

type TokenPayload = {
  document_id: number
  invitation_id: number
  signee_id: number
  exp: number
}

const useCurrentToken = () => {
  const params = useParams<{ token_id: string }>()
  const token_id = params.token_id as string

  const currentToken = useAppStore((state) => state.tokens[token_id])

  const decoded = useMemo(() => {
    if (!currentToken) return null
    try {
      return jwtDecode<TokenPayload>(currentToken)
    } catch {
      return null
    }
  }, [currentToken])

  // Return null values when token is not ready instead of throwing
  // This prevents race conditions during token initialization
  if (!currentToken || !decoded?.document_id) {
    return {
      currentToken: null,
      token_id,
      document_id: null,
      invitation_id: null,
      signee_id: null,
      exp: null,
      isReady: false,
    }
  }

  return {
    currentToken,
    token_id,
    ...decoded,
    isReady: true,
  }
}

export { useCurrentToken }
